// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HowlerPlayer_audioPlayer__z5nFz {
  width: 93%;
  background: linear-gradient(135deg, #2a0000 0%, #770000 100%);
  box-shadow: 0 -2px 15px rgba(0, 0, 0, 0.2);
  color: #fff;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  position: fixed;
  bottom: 10px;
  left: 0;
  z-index: 99999;
  padding: 14px 15px;
  border-radius: 1.5rem;
  margin-left: 2rem;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease-in-out;
}

.HowlerPlayer_playerContainer__4drrT {
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.HowlerPlayer_playerTopRow__e-vie {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

/* Left section - Episode info */
.HowlerPlayer_episodeInfo__BJrAA {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 50%;
  height: 80px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.HowlerPlayer_episodeInfo__BJrAA:hover {
  transform: scale(1.02);
}

.HowlerPlayer_coverImage__Q2LNf {
  width: auto;
  height: 80px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.HowlerPlayer_titleContainer__6AJzF {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.HowlerPlayer_episodeNumber__AX0fl {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 2px;
}

.HowlerPlayer_episodeTitle__2Yjoq {
  max-width: 100%;
  font-weight: 500;
  font-size: 1.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Center section - Playback controls */
.HowlerPlayer_centerControls__azJDu {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-bottom: 9px;
}

.HowlerPlayer_controlBtn__aFcBQ {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.HowlerPlayer_controlBtn__aFcBQ:hover {
  color: white;
  transform: scale(1.1);
}

.HowlerPlayer_shareBtn__Z-GI0 {
  color: rgba(255, 255, 255, 0.8);
}

.HowlerPlayer_shareBtn__Z-GI0:hover {
  color: white;
}

.HowlerPlayer_playPauseBtn__ShNNK {
  background: #ff3333;
  border: none;
  color: white;
  cursor: pointer;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(255, 51, 51, 0.3);
  transition: all 0.2s ease;
}

.HowlerPlayer_playPauseBtn__ShNNK:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 10px rgba(255, 51, 51, 0.4);
}

/* Right section - Speed control and buttons */
.HowlerPlayer_rightControls__moxN5 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  width: 33%;
}

.HowlerPlayer_rateButton__CpdGo {
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  color: white;
  padding: 4px 12px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 600;
}

.HowlerPlayer_rateButton__CpdGo:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.HowlerPlayer_volumeButton__SWkoR, .HowlerPlayer_closeButton__nrds2 {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  transition: all 0.2s ease;
}

.HowlerPlayer_volumeButton__SWkoR:hover, .HowlerPlayer_closeButton__nrds2:hover {
  color: white;
}

/* Grid container */
.HowlerPlayer_gridContainer__GFuyN {
  width: 530px;
}

/* Progress bar / seek container */
.HowlerPlayer_seekContainer__5i-WD {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.HowlerPlayer_timeDisplay__p5raj {
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  min-width: 40px;
  color: rgba(255, 255, 255, 0.8);
}

.HowlerPlayer_progressWrapper__PfA3m {
  flex: 1 1;
  position: relative;
  height: 4px;
}

.HowlerPlayer_seekBar__ig6Ys {
  width: 100%;
  appearance: none;
  height: 4px;
  background: linear-gradient(90deg, #ff3333 var(--seekPercent, 0%), rgba(255, 51, 51, 0.3) var(--seekPercent, 0%));
  border-radius: 2px;
  outline: none;
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
}

.HowlerPlayer_seekBar__ig6Ys::-webkit-slider-thumb {
  appearance: none;
  width: 12px;
  height: 12px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.HowlerPlayer_seekBar__ig6Ys::-moz-range-thumb {
  width: 12px;
  height: 12px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Share menu styling */
.HowlerPlayer_shareContainer__1mORU {
  position: relative;
  display: inline-block;
}

.HowlerPlayer_shareMenu__0baOc {
  position: absolute;
  right: 0;
  bottom: 100%;
  width: 140px;
  background-color: #222;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 10;
  padding: 6px 0;
  margin-bottom: 8px;
}

.HowlerPlayer_shareOption__t8FFd {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 6px 10px;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.2s;
  font-size: 13px;
}

.HowlerPlayer_shareOption__t8FFd:hover {
  background-color: #333;
}

.HowlerPlayer_shareOption__t8FFd span {
  margin-left: 8px;
}

/* SPOTIFY-STYLE FULL VIEW STYLES */
.HowlerPlayer_fullView__1JTTG {
  width: 100%;
  height: 100vh;
  margin: 0;
  border-radius: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(to bottom, #450000, #121212);
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  z-index: 22222;
}

.HowlerPlayer_fullViewContainer__rlPmQ {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 0;
  max-width: 100%;
  margin: 0 auto;
  position: relative;
}

.HowlerPlayer_fullViewHeader__EjB4n {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 24px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  background: linear-gradient(to bottom, rgba(40, 0, 0, 0.8) 0%, rgba(20, 0, 0, 0) 100%);
}

.HowlerPlayer_closeFullViewButton__cWARM {
  background: rgba(0, 0, 0, 0.3);
  border: none;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 16px;
}

.HowlerPlayer_closeFullViewButton__cWARM:hover {
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
}

.HowlerPlayer_fullViewContent__6l-9J {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 80px 24px 24px;
  position: relative;
  overflow-y: auto;
}

.HowlerPlayer_fullViewImageContainer__hRy5T {
  width: 100%;
  max-width: 300px;
  margin: 0 auto 24px;
  position: relative;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.HowlerPlayer_fullViewCoverImage__NIpbA {
  width: 100%;
  height: auto;
  aspect-ratio: auto;
  object-fit: cover;
  border-radius: 4px;
}

.HowlerPlayer_fullViewPlayOverlay__UrBK1 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.HowlerPlayer_fullViewImageContainer__hRy5T:hover .HowlerPlayer_fullViewPlayOverlay__UrBK1 {
  opacity: 1;
}

.HowlerPlayer_fullViewInfo__mHDjU {
  text-align: center;
  margin-bottom: 10px;
  padding: 0 16px;
}

.HowlerPlayer_fullViewTitle__7G8tg {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
  line-height: 1.2;
}

.HowlerPlayer_fullViewAuthor__q6R6e {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 0;
}

.HowlerPlayer_fullViewControlsWrapper__7LAP9 {
  margin-top: auto;
  padding: 0 16px;
}

.HowlerPlayer_fullViewSeekContainer__4LKSI {
  width: 100%;
  margin-bottom: 16px;
}

.HowlerPlayer_fullViewSeekBar__XEn7o {
  width: 100%;
  appearance: none;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  outline: none;
  margin: 0 0 8px;
  cursor: pointer;
}

.HowlerPlayer_fullViewSeekBar__XEn7o::-webkit-slider-thumb {
  appearance: none;
  width: 12px;
  height: 12px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.HowlerPlayer_fullViewSeekBar__XEn7o::-moz-range-thumb {
  width: 12px;
  height: 12px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.HowlerPlayer_fullViewTimeDisplay__AzNfy {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-variant-numeric: tabular-nums;
}

.HowlerPlayer_fullViewControls__0Mx2b {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-bottom: 32px;
}

.HowlerPlayer_fullViewControlBtn__RT86y {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  padding: 8px;
}

.HowlerPlayer_fullViewControlBtn__RT86y:hover {
  color: white;
  transform: scale(1.1);
}

.HowlerPlayer_fullViewPlayPauseBtn__tCJGR {
  background: #ff3333;
  border: none;
  color: white;
  cursor: pointer;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(255, 51, 51, 0.4);
  transition: all 0.2s ease;
}

.HowlerPlayer_fullViewPlayPauseBtn__tCJGR:hover {
  transform: scale(1.05);
  background: #ff4444;
  box-shadow: 0 6px 16px rgba(255, 51, 51, 0.5);
}

.HowlerPlayer_fullViewActionRow__d0ouN {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.HowlerPlayer_fullViewLeftActions__A21Wg, .HowlerPlayer_fullViewRightActions__ZaEOP {
  display: flex;
  align-items: center;
  gap: 16px;
}

.HowlerPlayer_fullViewActionBtn__\\+HinJ {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.HowlerPlayer_fullViewActionBtn__\\+HinJ:hover {
  color: white;
}

.HowlerPlayer_fullViewVolumeControl__Nt0L4 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.HowlerPlayer_fullViewVolumeBtn__xmn3A {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.HowlerPlayer_fullViewVolumeBtn__xmn3A:hover {
  color: white;
}

.HowlerPlayer_fullViewVolumeSlider__QiAXt {
  width: 80px;
  appearance: none;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  outline: none;
  cursor: pointer;
}

.HowlerPlayer_fullViewVolumeSlider__QiAXt::-webkit-slider-thumb {
  appearance: none;
  width: 12px;
  height: 12px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.HowlerPlayer_fullViewVolumeSlider__QiAXt::-moz-range-thumb {
  width: 12px;
  height: 12px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Responsive styles */
@media (min-width: 768px) {
  .HowlerPlayer_fullViewContent__6l-9J {
    max-width: 1400px;
    width: 100%;
    margin: 0 auto;
    padding-top: 100px !important;
    padding: 0;
  }
  
  .HowlerPlayer_fullViewImageContainer__hRy5T {
    max-width: 200px;
  }
  
  .HowlerPlayer_fullViewPlayOverlay__UrBK1 {
    opacity: 0;
  }
  
  .HowlerPlayer_fullViewImageContainer__hRy5T:hover .HowlerPlayer_fullViewPlayOverlay__UrBK1 {
    opacity: 1;
  }
}

@media (max-width: 1024px) {
  .HowlerPlayer_fullViewControls__0Mx2b {
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .HowlerPlayer_episodeInfo__BJrAA {
    justify-content: flex-start;
    width: 40%;
  }
  
  .HowlerPlayer_centerControls__azJDu {
    justify-content: center;
    order: 3;
  }
  
  .HowlerPlayer_episodeTitle__2Yjoq {
    max-width: calc(100% - 60px);
    font-size: 1.2rem;
  }
  
  .HowlerPlayer_gridContainer__GFuyN {
    width: 40%;
  }
  
  .HowlerPlayer_rightControls__moxN5 {
    width: 20%;
  }
  
  .HowlerPlayer_fullViewHeader__EjB4n {
    padding: 12px 16px;
  }
  
  .HowlerPlayer_fullViewContent__6l-9J {
    padding: 70px 16px 16px;
  }
  
  .HowlerPlayer_fullViewImageContainer__hRy5T {
    max-width: 250px;
    margin-bottom: 16px;
  }
  
  .HowlerPlayer_fullViewTitle__7G8tg {
    font-size: 24px;
  }
  
  .HowlerPlayer_fullViewControls__0Mx2b {
    gap: 16px;
    margin-bottom: 24px;
  }
  
  .HowlerPlayer_fullViewPlayPauseBtn__tCJGR {
    width: 48px;
    height: 48px;
  }
  
  .HowlerPlayer_fullViewActionRow__d0ouN {
    flex-wrap: wrap;
  }
}

@media (max-width: 480px) {
  .HowlerPlayer_audioPlayer__z5nFz {
    width: 100%;
    margin-left: 0px;
    padding: 0px;
  }
  .HowlerPlayer_playerContainer__4drrT{
    max-width: 100%;
  }
  .HowlerPlayer_episodeInfo__BJrAA {
    gap: 8px;
    width: 40%;
  }
  .HowlerPlayer_episodeTitle__2Yjoq{
    max-width: 50px;
  }
  
  .HowlerPlayer_coverImage__Q2LNf {
    width: 60px;
    height: 60px;
  }
  
  .HowlerPlayer_rateButton__CpdGo {
    display: none;
  }
  
  .HowlerPlayer_episodeTitle__2Yjoq {
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .HowlerPlayer_full__IRAEy
  .HowlerPlayer_episodeNumber__AX0fl {
    font-size: 11px;
  }
  
  .HowlerPlayer_centerControls__azJDu {
    gap: 12px;
  }
  
  .HowlerPlayer_playPauseBtn__ShNNK {
    width: 34px;
    height: 34px;
  }
  
  .HowlerPlayer_timeDisplay__p5raj {
    font-size: 11px;
    min-width: 30px;
  }
  
  .HowlerPlayer_seekContainer__5i-WD {
    display: none;
  }
  
  .HowlerPlayer_volumeButton__SWkoR {
    display: none;
  }
  
  .HowlerPlayer_gridContainer__GFuyN {
    width: 120px;
  }
  
  .HowlerPlayer_rightControls__moxN5 {
    width: 25%;
    gap: 8px;
  }
  
  .HowlerPlayer_darkMode__ADfwX {
    display: none;
  }
  
  .HowlerPlayer_shareBtn__Z-GI0 {
    display: block;
  }
  
  /* Full view mobile styles */
  .HowlerPlayer_fullViewHeader__EjB4n {
    padding: 80px 12px;
  }
  .HowlerPlayer_fullViewControlsWrapper__7LAP9{
    margin-top: 0;
  }
  
  .HowlerPlayer_fullViewContent__6l-9J {
    padding: 0;
  }
  
  .HowlerPlayer_fullViewImageContainer__hRy5T {
    max-width: 100%;
    margin-bottom: 16px;
  }
  
  .HowlerPlayer_fullViewTitle__7G8tg {
    font-size: 20px;
  }
  
  .HowlerPlayer_fullViewAuthor__q6R6e {
    font-size: 14px;
  }
  
  .HowlerPlayer_fullViewControls__0Mx2b {
    gap: 12px;
    margin-bottom: 16px;
  }
  
  .HowlerPlayer_fullViewPlayPauseBtn__tCJGR {
    width: 44px;
    height: 44px;
  }
  
  .HowlerPlayer_fullViewLeftActions__A21Wg, .HowlerPlayer_fullViewRightActions__ZaEOP {
    gap: 8px;
  }
  
  .HowlerPlayer_fullViewVolumeSlider__QiAXt {
    width: 60px;
  }
}

/* Portrait tablet and landscape phone styles */
@media (max-height: 700px) and (orientation: landscape) {
  .HowlerPlayer_fullViewContent__6l-9J {
    padding-top: 60px;
    flex-direction: row;
    align-items: center;
    gap: 24px;
  }
  
  .HowlerPlayer_fullViewHeader__EjB4n {
    padding: 8px 16px;
  }
  
  .HowlerPlayer_fullViewImageContainer__hRy5T {
    flex-shrink: 0;
    margin-bottom: 0;
    max-width: 200px;
  }
  
  .HowlerPlayer_fullViewInfo__mHDjU {
    text-align: left;
    margin-bottom: 16px;
  }
  
  .HowlerPlayer_fullViewControlsWrapper__7LAP9 {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/audio/howlerPlayer/HowlerPlayer.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,6DAA6D;EAC7D,0CAA0C;EAC1C,WAAW;EACX,yFAAyF;EACzF,eAAe;EACf,YAAY;EACZ,OAAO;EACP,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EAEX,gBAAgB;EAChB,WAAW;EACX,iHAAiH;EACjH,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;AACX;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,wCAAwC;AAC1C;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,OAAO;EACP,wDAAwD;EACxD,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,UAAU;EACV,sFAAsF;AACxF;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EAEX,gBAAgB;EAChB,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EAEX,gBAAgB;EAChB,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;;IAEE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA,4BAA4B;EAC5B;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".audioPlayer {\n  width: 93%;\n  background: linear-gradient(135deg, #2a0000 0%, #770000 100%);\n  box-shadow: 0 -2px 15px rgba(0, 0, 0, 0.2);\n  color: #fff;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  position: fixed;\n  bottom: 10px;\n  left: 0;\n  z-index: 99999;\n  padding: 14px 15px;\n  border-radius: 1.5rem;\n  margin-left: 2rem;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease-in-out;\n}\n\n.playerContainer {\n  max-width: 100%;\n  width: 100%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.playerTopRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n/* Left section - Episode info */\n.episodeInfo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 50%;\n  height: 80px;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\n.episodeInfo:hover {\n  transform: scale(1.02);\n}\n\n.coverImage {\n  width: auto;\n  height: 80px;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.titleContainer {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.episodeNumber {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.7);\n  margin-bottom: 2px;\n}\n\n.episodeTitle {\n  max-width: 100%;\n  font-weight: 500;\n  font-size: 1.5rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Center section - Playback controls */\n.centerControls {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n  margin-bottom: 9px;\n}\n\n.controlBtn {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.8);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.controlBtn:hover {\n  color: white;\n  transform: scale(1.1);\n}\n\n.shareBtn {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.shareBtn:hover {\n  color: white;\n}\n\n.playPauseBtn {\n  background: #ff3333;\n  border: none;\n  color: white;\n  cursor: pointer;\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 6px rgba(255, 51, 51, 0.3);\n  transition: all 0.2s ease;\n}\n\n.playPauseBtn:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 10px rgba(255, 51, 51, 0.4);\n}\n\n/* Right section - Speed control and buttons */\n.rightControls {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 16px;\n  width: 33%;\n}\n\n.rateButton {\n  background: none;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 4px;\n  color: white;\n  padding: 4px 12px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-weight: 600;\n}\n\n.rateButton:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.volumeButton, .closeButton {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.8);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  transition: all 0.2s ease;\n}\n\n.volumeButton:hover, .closeButton:hover {\n  color: white;\n}\n\n/* Grid container */\n.gridContainer {\n  width: 530px;\n}\n\n/* Progress bar / seek container */\n.seekContainer {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n.timeDisplay {\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n  min-width: 40px;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.progressWrapper {\n  flex: 1;\n  position: relative;\n  height: 4px;\n}\n\n.seekBar {\n  width: 100%;\n  -webkit-appearance: none;\n  appearance: none;\n  height: 4px;\n  background: linear-gradient(90deg, #ff3333 var(--seekPercent, 0%), rgba(255, 51, 51, 0.3) var(--seekPercent, 0%));\n  border-radius: 2px;\n  outline: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  margin: 0;\n}\n\n.seekBar::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 12px;\n  height: 12px;\n  background: #fff;\n  border-radius: 50%;\n  cursor: pointer;\n  border: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.seekBar::-moz-range-thumb {\n  width: 12px;\n  height: 12px;\n  background: #fff;\n  border-radius: 50%;\n  cursor: pointer;\n  border: none;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n/* Share menu styling */\n.shareContainer {\n  position: relative;\n  display: inline-block;\n}\n\n.shareMenu {\n  position: absolute;\n  right: 0;\n  bottom: 100%;\n  width: 140px;\n  background-color: #222;\n  border-radius: 6px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  z-index: 10;\n  padding: 6px 0;\n  margin-bottom: 8px;\n}\n\n.shareOption {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 6px 10px;\n  background: none;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  text-align: left;\n  transition: background-color 0.2s;\n  font-size: 13px;\n}\n\n.shareOption:hover {\n  background-color: #333;\n}\n\n.shareOption span {\n  margin-left: 8px;\n}\n\n/* SPOTIFY-STYLE FULL VIEW STYLES */\n.fullView {\n  width: 100%;\n  height: 100vh;\n  margin: 0;\n  border-radius: 0;\n  bottom: 0;\n  left: 0;\n  background: linear-gradient(to bottom, #450000, #121212);\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  z-index: 22222;\n}\n\n.fullViewContainer {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  padding: 0;\n  max-width: 100%;\n  margin: 0 auto;\n  position: relative;\n}\n\n.fullViewHeader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 30px 24px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n  background: linear-gradient(to bottom, rgba(40, 0, 0, 0.8) 0%, rgba(20, 0, 0, 0) 100%);\n}\n\n.closeFullViewButton {\n  background: rgba(0, 0, 0, 0.3);\n  border: none;\n  color: rgba(255, 255, 255, 0.9);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  left: 16px;\n}\n\n.closeFullViewButton:hover {\n  background: rgba(0, 0, 0, 0.5);\n  color: #fff;\n}\n\n.fullViewContent {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 80px 24px 24px;\n  position: relative;\n  overflow-y: auto;\n}\n\n.fullViewImageContainer {\n  width: 100%;\n  max-width: 300px;\n  margin: 0 auto 24px;\n  position: relative;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n}\n\n.fullViewCoverImage {\n  width: 100%;\n  height: auto;\n  aspect-ratio: auto;\n  object-fit: cover;\n  border-radius: 4px;\n}\n\n.fullViewPlayOverlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 4px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.fullViewImageContainer:hover .fullViewPlayOverlay {\n  opacity: 1;\n}\n\n.fullViewInfo {\n  text-align: center;\n  margin-bottom: 10px;\n  padding: 0 16px;\n}\n\n.fullViewTitle {\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  line-height: 1.2;\n}\n\n.fullViewAuthor {\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.7);\n  margin-bottom: 0;\n}\n\n.fullViewControlsWrapper {\n  margin-top: auto;\n  padding: 0 16px;\n}\n\n.fullViewSeekContainer {\n  width: 100%;\n  margin-bottom: 16px;\n}\n\n.fullViewSeekBar {\n  width: 100%;\n  -webkit-appearance: none;\n  appearance: none;\n  height: 4px;\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 2px;\n  outline: none;\n  margin: 0 0 8px;\n  cursor: pointer;\n}\n\n.fullViewSeekBar::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 12px;\n  height: 12px;\n  background: #fff;\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.fullViewSeekBar::-moz-range-thumb {\n  width: 12px;\n  height: 12px;\n  background: #fff;\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.fullViewTimeDisplay {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.7);\n  font-variant-numeric: tabular-nums;\n}\n\n.fullViewControls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.fullViewControlBtn {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.9);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  padding: 8px;\n}\n\n.fullViewControlBtn:hover {\n  color: white;\n  transform: scale(1.1);\n}\n\n.fullViewPlayPauseBtn {\n  background: #ff3333;\n  border: none;\n  color: white;\n  cursor: pointer;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 12px rgba(255, 51, 51, 0.4);\n  transition: all 0.2s ease;\n}\n\n.fullViewPlayPauseBtn:hover {\n  transform: scale(1.05);\n  background: #ff4444;\n  box-shadow: 0 6px 16px rgba(255, 51, 51, 0.5);\n}\n\n.fullViewActionRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.fullViewLeftActions, .fullViewRightActions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.fullViewActionBtn {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.7);\n  cursor: pointer;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.fullViewActionBtn:hover {\n  color: white;\n}\n\n.fullViewVolumeControl {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.fullViewVolumeBtn {\n  background: none;\n  border: none;\n  color: rgba(255, 255, 255, 0.7);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.fullViewVolumeBtn:hover {\n  color: white;\n}\n\n.fullViewVolumeSlider {\n  width: 80px;\n  -webkit-appearance: none;\n  appearance: none;\n  height: 4px;\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 2px;\n  outline: none;\n  cursor: pointer;\n}\n\n.fullViewVolumeSlider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 12px;\n  height: 12px;\n  background: #fff;\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.fullViewVolumeSlider::-moz-range-thumb {\n  width: 12px;\n  height: 12px;\n  background: #fff;\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n/* Responsive styles */\n@media (min-width: 768px) {\n  .fullViewContent {\n    max-width: 1400px;\n    width: 100%;\n    margin: 0 auto;\n    padding-top: 100px !important;\n    padding: 0;\n  }\n  \n  .fullViewImageContainer {\n    max-width: 200px;\n  }\n  \n  .fullViewPlayOverlay {\n    opacity: 0;\n  }\n  \n  .fullViewImageContainer:hover .fullViewPlayOverlay {\n    opacity: 1;\n  }\n}\n\n@media (max-width: 1024px) {\n  .fullViewControls {\n    gap: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .episodeInfo {\n    justify-content: flex-start;\n    width: 40%;\n  }\n  \n  .centerControls {\n    justify-content: center;\n    order: 3;\n  }\n  \n  .episodeTitle {\n    max-width: calc(100% - 60px);\n    font-size: 1.2rem;\n  }\n  \n  .gridContainer {\n    width: 40%;\n  }\n  \n  .rightControls {\n    width: 20%;\n  }\n  \n  .fullViewHeader {\n    padding: 12px 16px;\n  }\n  \n  .fullViewContent {\n    padding: 70px 16px 16px;\n  }\n  \n  .fullViewImageContainer {\n    max-width: 250px;\n    margin-bottom: 16px;\n  }\n  \n  .fullViewTitle {\n    font-size: 24px;\n  }\n  \n  .fullViewControls {\n    gap: 16px;\n    margin-bottom: 24px;\n  }\n  \n  .fullViewPlayPauseBtn {\n    width: 48px;\n    height: 48px;\n  }\n  \n  .fullViewActionRow {\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 480px) {\n  .audioPlayer {\n    width: 100%;\n    margin-left: 0px;\n    padding: 0px;\n  }\n  .playerContainer{\n    max-width: 100%;\n  }\n  .episodeInfo {\n    gap: 8px;\n    width: 40%;\n  }\n  .episodeTitle{\n    max-width: 50px;\n  }\n  \n  .coverImage {\n    width: 60px;\n    height: 60px;\n  }\n  \n  .rateButton {\n    display: none;\n  }\n  \n  .episodeTitle {\n    font-size: 16px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  .full\n  .episodeNumber {\n    font-size: 11px;\n  }\n  \n  .centerControls {\n    gap: 12px;\n  }\n  \n  .playPauseBtn {\n    width: 34px;\n    height: 34px;\n  }\n  \n  .timeDisplay {\n    font-size: 11px;\n    min-width: 30px;\n  }\n  \n  .seekContainer {\n    display: none;\n  }\n  \n  .volumeButton {\n    display: none;\n  }\n  \n  .gridContainer {\n    width: 120px;\n  }\n  \n  .rightControls {\n    width: 25%;\n    gap: 8px;\n  }\n  \n  .darkMode {\n    display: none;\n  }\n  \n  .shareBtn {\n    display: block;\n  }\n  \n  /* Full view mobile styles */\n  .fullViewHeader {\n    padding: 80px 12px;\n  }\n  .fullViewControlsWrapper{\n    margin-top: 0;\n  }\n  \n  .fullViewContent {\n    padding: 0;\n  }\n  \n  .fullViewImageContainer {\n    max-width: 100%;\n    margin-bottom: 16px;\n  }\n  \n  .fullViewTitle {\n    font-size: 20px;\n  }\n  \n  .fullViewAuthor {\n    font-size: 14px;\n  }\n  \n  .fullViewControls {\n    gap: 12px;\n    margin-bottom: 16px;\n  }\n  \n  .fullViewPlayPauseBtn {\n    width: 44px;\n    height: 44px;\n  }\n  \n  .fullViewLeftActions, .fullViewRightActions {\n    gap: 8px;\n  }\n  \n  .fullViewVolumeSlider {\n    width: 60px;\n  }\n}\n\n/* Portrait tablet and landscape phone styles */\n@media (max-height: 700px) and (orientation: landscape) {\n  .fullViewContent {\n    padding-top: 60px;\n    flex-direction: row;\n    align-items: center;\n    gap: 24px;\n  }\n  \n  .fullViewHeader {\n    padding: 8px 16px;\n  }\n  \n  .fullViewImageContainer {\n    flex-shrink: 0;\n    margin-bottom: 0;\n    max-width: 200px;\n  }\n  \n  .fullViewInfo {\n    text-align: left;\n    margin-bottom: 16px;\n  }\n  \n  .fullViewControlsWrapper {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"audioPlayer": `HowlerPlayer_audioPlayer__z5nFz`,
	"playerContainer": `HowlerPlayer_playerContainer__4drrT`,
	"playerTopRow": `HowlerPlayer_playerTopRow__e-vie`,
	"episodeInfo": `HowlerPlayer_episodeInfo__BJrAA`,
	"coverImage": `HowlerPlayer_coverImage__Q2LNf`,
	"titleContainer": `HowlerPlayer_titleContainer__6AJzF`,
	"episodeNumber": `HowlerPlayer_episodeNumber__AX0fl`,
	"episodeTitle": `HowlerPlayer_episodeTitle__2Yjoq`,
	"centerControls": `HowlerPlayer_centerControls__azJDu`,
	"controlBtn": `HowlerPlayer_controlBtn__aFcBQ`,
	"shareBtn": `HowlerPlayer_shareBtn__Z-GI0`,
	"playPauseBtn": `HowlerPlayer_playPauseBtn__ShNNK`,
	"rightControls": `HowlerPlayer_rightControls__moxN5`,
	"rateButton": `HowlerPlayer_rateButton__CpdGo`,
	"volumeButton": `HowlerPlayer_volumeButton__SWkoR`,
	"closeButton": `HowlerPlayer_closeButton__nrds2`,
	"gridContainer": `HowlerPlayer_gridContainer__GFuyN`,
	"seekContainer": `HowlerPlayer_seekContainer__5i-WD`,
	"timeDisplay": `HowlerPlayer_timeDisplay__p5raj`,
	"progressWrapper": `HowlerPlayer_progressWrapper__PfA3m`,
	"seekBar": `HowlerPlayer_seekBar__ig6Ys`,
	"shareContainer": `HowlerPlayer_shareContainer__1mORU`,
	"shareMenu": `HowlerPlayer_shareMenu__0baOc`,
	"shareOption": `HowlerPlayer_shareOption__t8FFd`,
	"fullView": `HowlerPlayer_fullView__1JTTG`,
	"fullViewContainer": `HowlerPlayer_fullViewContainer__rlPmQ`,
	"fullViewHeader": `HowlerPlayer_fullViewHeader__EjB4n`,
	"closeFullViewButton": `HowlerPlayer_closeFullViewButton__cWARM`,
	"fullViewContent": `HowlerPlayer_fullViewContent__6l-9J`,
	"fullViewImageContainer": `HowlerPlayer_fullViewImageContainer__hRy5T`,
	"fullViewCoverImage": `HowlerPlayer_fullViewCoverImage__NIpbA`,
	"fullViewPlayOverlay": `HowlerPlayer_fullViewPlayOverlay__UrBK1`,
	"fullViewInfo": `HowlerPlayer_fullViewInfo__mHDjU`,
	"fullViewTitle": `HowlerPlayer_fullViewTitle__7G8tg`,
	"fullViewAuthor": `HowlerPlayer_fullViewAuthor__q6R6e`,
	"fullViewControlsWrapper": `HowlerPlayer_fullViewControlsWrapper__7LAP9`,
	"fullViewSeekContainer": `HowlerPlayer_fullViewSeekContainer__4LKSI`,
	"fullViewSeekBar": `HowlerPlayer_fullViewSeekBar__XEn7o`,
	"fullViewTimeDisplay": `HowlerPlayer_fullViewTimeDisplay__AzNfy`,
	"fullViewControls": `HowlerPlayer_fullViewControls__0Mx2b`,
	"fullViewControlBtn": `HowlerPlayer_fullViewControlBtn__RT86y`,
	"fullViewPlayPauseBtn": `HowlerPlayer_fullViewPlayPauseBtn__tCJGR`,
	"fullViewActionRow": `HowlerPlayer_fullViewActionRow__d0ouN`,
	"fullViewLeftActions": `HowlerPlayer_fullViewLeftActions__A21Wg`,
	"fullViewRightActions": `HowlerPlayer_fullViewRightActions__ZaEOP`,
	"fullViewActionBtn": `HowlerPlayer_fullViewActionBtn__+HinJ`,
	"fullViewVolumeControl": `HowlerPlayer_fullViewVolumeControl__Nt0L4`,
	"fullViewVolumeBtn": `HowlerPlayer_fullViewVolumeBtn__xmn3A`,
	"fullViewVolumeSlider": `HowlerPlayer_fullViewVolumeSlider__QiAXt`,
	"full": `HowlerPlayer_full__IRAEy`,
	"darkMode": `HowlerPlayer_darkMode__ADfwX`
};
export default ___CSS_LOADER_EXPORT___;
